import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useParams,
} from "react";
import { theme } from "../../..";
import ClipLoader from "react-spinners/ClipLoader";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "../../../components/modal/modal";
import RednerSingleSectionItem from "./RednerSingleSectionItem";
import SectionQuestions from "./SectionQuestions";
import {
  addSection,
  getTestSeriesById,
  fetch_institute_testSeries_section,
} from "../../../api/testSeries/testseries";
import Select from "react-select";
import { Shimmer } from "react-shimmer";

const Sections = forwardRef(
  ({ activeSection, setActiveSection, testSeriesId }, ref) => {
    const [addSectionModalVisible, setAddSectionModalVisible] = useState(false);
    const [addSectionData, setAddSectionData] = useState({});
    const [testSeriesData, setTestSeriesData] = useState({});
    const [sections, setSections] = useState([]);
    const [OptionalSections, setOptionalSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState([]);
    const [addSectionLoading, setAddSectionLoading] = useState();
    const [savingSectionData, setSavingSectionData] = useState(false);
    const [fetchingSection, setFetchingSection] = useState(true);
    const titleInputRef = useRef();
    const sectionTimeInputRef = useRef();
    const maxScoreInputRef = useRef();
    const compulsoryQuestionCountInputRef = useRef();
    const counterRef = useRef(1);
    const totalQuestionToBePublishedInputRef = useRef();

    useImperativeHandle(ref, () => ({
      openAddSectionModal: () => {
        setAddSectionModalVisible(true);
      },
      hideAddSectionModal: () => {
        setAddSectionModalVisible(false);
      },
      fetchSections: fetchSections,
    }));

    const appendSectionInState = (newSection) => {
      const sections_arr = [...sections];
      sections_arr.push(newSection);
      setSections(sections_arr);
    };

    const deleteSectionFromStateAtIndex = (response, index) => {
      if (response.status === 200) {
        const arr = [...sections];
        arr.splice(index, 1);
        setSections(arr);
      }
    };

    const handleSectionAddDataInput = (e) => {
      const sectionData = { ...addSectionData };
      sectionData[e.target.name] = e.target.value;
      sectionData["testSeries"] = { id: testSeriesId };
      setAddSectionData(sectionData);

    };

    const addSectionHandler = async (e) => {
      e.preventDefault();
      setSavingSectionData(true);
      setAddSectionLoading(true);
      // const optionalSec=[]
      // setSelectedSection([])
      // selectedSection.map((val,i) =>{
      //   optionalSec.push(val.value)
      // })
      // addSectionData.optionalSections = [...optionalSec]
      addSection(addSectionData, (response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            console.log("section data", data);
            const arr = [...sections];
            arr.push(data?.data);
            setSections(arr);
          });
          setAddSectionData({});
        }
        setSavingSectionData(false);
        setSelectedSection([]);
        setAddSectionLoading(false);
      });
      counterRef.current = counterRef.current + 1;
      setAddSectionData({});
      titleInputRef.current.value = "";
      compulsoryQuestionCountInputRef.current.value = "";
      setAddSectionModalVisible(false);
      setSavingSectionData(false);
    };

    // const handleSelectChange = (data) => {
    //     setSelectedSection(data)
    // }

    const updateSectionAtIndex = (updatedSectionData, index) => {
      const arr = [...sections];
      arr[index] = updatedSectionData;
      setSections(arr);
    };

    useEffect(() => {
      getTestSeriesById(testSeriesId, (response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            setTestSeriesData(data?.data);
          });
        }
      });
      fetchSections();
    }, []);

    const fetchSections = () => {
      fetch_institute_testSeries_section(testSeriesId, (response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            console.log("section", data);
            setSections(data?.data);
            if (data?.data?.length === 0) {
              setAddSectionModalVisible(true);
            } else {
              setAddSectionModalVisible(false);
            }
          });
          setFetchingSection(false);
        }
      });
    };

    useEffect(() => {
      if (sections?.length > 0) {
        setActiveSection(sections[0]);
      }
    }, [sections]);

    useEffect(() => {
      const arr = [];
      sections.map((val, i) => {
        const obj = {};
        obj.value = val.id;
        obj.label = val.title;
        arr.push(obj);
      });
      setOptionalSections(arr);
    }, [sections]);

    return (
      <div style={{ width: "100%" }}>
        <div className="row">
          <div class="card radius-15" style={{ width: "100%" }}>
            <div class="card-body">
              <div class="card-title">
                <h4 class="mb-0"></h4>
              </div>
              <hr />

              <ul class="nav nav-tabs" id="myTab" role="tablist">
                {fetchingSection ? (
                  <Shimmer width={"100%"} height={40} />
                ) : (
                  sections?.map((item, index) => {
                    return (
                      <RednerSingleSectionItem
                        qCount={item.qCount}
                        OptionalSections={OptionalSections}
                        updateSectionAtIndex={updateSectionAtIndex}
                        index={index}
                        deleteSectionFromStateAtIndex={
                          deleteSectionFromStateAtIndex
                        }
                        setActiveSection={setActiveSection}
                        isActive={activeSection?.id === item.id}
                        item={item}
                        testSeriesId={testSeriesId}
                        secLength={sections?.length}
                        sections={sections}
                        setOptionalSections={setOptionalSections}
                      />
                    );
                  })
                )}
              </ul>
              <div class="tab-content p-3 w-100" id="myTabContent">
                {activeSection?.id ? (
                  <SectionQuestions activeSection={activeSection} />
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <Modal
          visible={addSectionModalVisible}
          setModalVisible={setAddSectionModalVisible}
          modalId={"sectionAddModal"}
        >
          <form onSubmit={addSectionHandler}>
            <ModalHeader>
              <h5 class="modal-title" id="exampleModalLabel">
                Add Section
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="true">&times;</span>
              </button>
            </ModalHeader>
            <ModalBody>
              <div>
                <label>Section Name</label>
                <input
                  ref={titleInputRef}
                  className="form-control"
                  value={addSectionData["title"]}
                  name="title"
                  required
                  placeholder="Section Name"
                  onChange={handleSectionAddDataInput}
                />
              </div>
              <div>
                <label>Compulsory Question Count</label>
                <input
                  ref={compulsoryQuestionCountInputRef}
                  className="form-control"
                  value={addSectionData["compulsoryQuestions"]}
                  name="compulsoryQuestions"
                  required
                  placeholder="Compulsory Question Count"
                  onChange={handleSectionAddDataInput}
                />
              </div>
              <div>
                <label>Total Questions To be Published</label>
                <input
                  ref={totalQuestionToBePublishedInputRef}
                  className="form-control"
                  value={addSectionData["totalQuestionToBePublished"]}
                  name="totalQuestionToBePublished"
                  required
                  placeholder="Total Questions To Be Published Count"
                  onChange={handleSectionAddDataInput}
                />
              </div>
              <div>
                <label>Max Score</label>
                <input
                  ref={maxScoreInputRef}
                  className="form-control"
                  value={addSectionData["maxScore"]}
                  name="maxScore"
                  required
                  placeholder="Max Score"
                  onChange={handleSectionAddDataInput}
                />
              </div>
              {testSeriesData?.sectionTimeSharedFlag ? (
                <div>
                  <label>Section Time</label>
                  <input
                    ref={sectionTimeInputRef}
                    className="form-control"
                    value={addSectionData["ime"]}
                    name="time"
                    required
                    placeholder="Time"
                    onChange={handleSectionAddDataInput}
                  />
                </div>
              ) : null}
              {/* {sections?.length>0?(
              <div>
                <label>Select Optional Section</label>
                <Select required={false} name="languages" class="custom-select" id="validationCustom04" placeholder="Select Optional Sections"  isMulti onChange={handleSelectChange} options={OptionalSections} />
              </div>
            ):(null)} */}
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                id="addPlaylistCloseBtn"
              >
                Close
              </button>
              <button class="btn btn-primary">
                {addSectionLoading ? (
                  <ClipLoader
                    color={theme.primaryColor}
                    loading={addSectionLoading}
                  />
                ) : (
                  "Save changes"
                )}
              </button>
            </ModalFooter>
          </form>
        </Modal>
      </div>
    );
  }
);

export default Sections;
